<template>
  <div>
    <!-- TRIED USING input group to add a button on the end but it interacts with the span added by Algolia with class algolia-autocomplete belw and breaks 100% width -->
<!--    <b-input-group size="lg">-->
      <b-form-input
        v-model="address"
        type="search"
        :ref="`refAddress${id}`"
        :id="`address${id}`"
        @focus="resetField"
        v-bind:disabled="disabled"
        v-bind:placeholder="'\u2315 ' + placeholder"
        style="padding: 6px;"
      />
<!--      <b-input-group-text slot="append">X</b-input-group-text>-->
<!--    </b-input-group>-->
  </div>
</template>

<script>
// ***************************************************************************************************
//    This is derived from the components/widgets/AddressSearchField.vue in the treetalk-website-v5 repository
// ***************************************************************************************************

import _config from '../config';
import Vue from 'vue';

// styles are imported in style section and not needed here
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import {BFormInput} from 'bootstrap-vue';

// In main treetalk it uses the script installed library via nuxt.config.js
// [script src="https://cdn.jsdelivr.net/autocomplete.js/0/autocomplete.min.js"][/script]
// Here trying to use the npm installed lib instead
// https://github.com/algolia/autocomplete.js
// npm install --save autocomplete.js
import autocomplete from 'autocomplete.js';

// This one seems compatible with SSR so included here
// https://www.algolia.com/doc/guides/building-search-ui/going-further/server-side-rendering/vue/
// FUTURE: Perhaps could use these VUE Widgets https://www.algolia.com/doc/api-reference/widgets/vue/ set of InstantSearch or is that not customisable enough?
// main doco: https://github.com/algolia/autocomplete.js
import algoliasearch from 'algoliasearch/lite';

// MapBOX API
// API: https://docs.mapbox.com/api/search/#geocoding
// Working with Javascript SDK: https://github.com/mapbox/mapbox-sdk-js
const mbxSearch = require('@mapbox/mapbox-sdk/services/geocoding');
const searchService = mbxSearch({ accessToken: _config.mapboxAccessTokenAddressLookup });

export default {
  name: 'address-search-field',
  components: {
    'b-form-input': BFormInput,
  },
  model: {
    prop: 'addressDetails', // Define the property and the event which will be emitted (not the default 'value' property since that is used for the input element itself and causes errors if I try and set it to return it. https://vuejs.org/v2/guide/components-custom-events.html
    event: 'got-address'
  },
  data () {
    return (
      {
        // id: null, // This component's unique id, used to reference e.g. HTML elements so not finding duplicates on page
        id: null, // This component's unique id, used to reference e.g. HTML elements so not finding duplicates on page
        htmlElement: null,
        address: null, // as typed in (just the characters typed in initially)
        addressLat: null, // Calculated by the Place search when search, or set from POI Lat when startType='POI'
        addressLon: null, // ditto
      }
    );
  },
  props: [
    // OUTPUT
    // the output value of this component which can be attached to by the parent using v-model https://vuejs.org/v2/guide/components.html#Sending-Messages-to-Parents-with-Events
    // {address, addressLat, addressLon}
    'addressDetails',

    // INPUT
    'disabled',
    'placeholder',
    'startType', // one of address, POI
    'startPOIName', // name of the start PoI - if set then the user is not selecting start location
    'startPOILat',
    'startPOILon',
    'forceFocus', // will cause focus into the correct field as widget is rendered, but this will also scroll the webpage so perhaps not always what want
    'suggestAddressesFirst'
  ],
  created: function () {
    // const that = this;
  },
  mounted: function () {
    // ------------------------- Algolia autocomplete widget with Algolia Parks instantsearch and Mapbox geocode address search ------------------------------
    // https://community.algolia.com/places/examples.html#autocompletejs
    // https://community.algolia.com/places/examples.html#places--custom-data
    // console.log('address-search-field: mounted');
    var that = this;

    // this component's unique id so that the tags can be unique
    this.id = this._uid;

    // Need to wait for the address<id> element to be fully rendered to the DOM before trying to reference it in the search setup code below.
    Vue.nextTick(function () {
      // container IS finished rendering to the DOM

      (function () {
        // Attach to the Algolia search index setup as "prod_FMP_PLACES_GOPARKS"
        var client = algoliasearch('863DPYF6PV', 'defa837c9d2b760d58b452349e9a13d0');
        var index = client.initIndex('prod_FMP_PLACES_GOPARKS');

        // create the first autocomplete.js dataset: against Algolia hits source
        // https://github.com/algolia/autocomplete.js#hits
        // main doco: https://github.com/algolia/autocomplete.js
        var poisDataset = {
          source: autocomplete.sources.hits(index, {hitsPerPage: 3}),
          displayKey: 'name',
          name: 'prod_FMP_PLACES_GOPARKS',
          templates: {
            header: '<div class="ad-autocomp-header">Parks</div>',
            suggestion: function (suggest) {
              // console.log(suggest);
              return `<div>
                <span class="ap-suggestion-icon ap-suggestion-icon-poi" style="white-space: normal;"><svg width="20" height="20" aria-hidden="true" data-prefix="fas" data-icon="sun" class="svg-inline--fa fa-sun fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M274.835 12.646l25.516 62.393c4.213 10.301 16.671 14.349 26.134 8.492l57.316-35.479c15.49-9.588 34.808 4.447 30.475 22.142l-16.03 65.475c-2.647 10.81 5.053 21.408 16.152 22.231l67.224 4.987c18.167 1.348 25.546 24.057 11.641 35.826L441.81 242.26c-8.495 7.19-8.495 20.289 0 27.479l51.454 43.548c13.906 11.769 6.527 34.478-11.641 35.826l-67.224 4.987c-11.099.823-18.799 11.421-16.152 22.231l16.03 65.475c4.332 17.695-14.986 31.73-30.475 22.142l-57.316-35.479c-9.463-5.858-21.922-1.81-26.134 8.492l-25.516 62.393c-6.896 16.862-30.774 16.862-37.67 0l-25.516-62.393c-4.213-10.301-16.671-14.349-26.134-8.492l-57.317 35.479c-15.49 9.588-34.808-4.447-30.475-22.142l16.03-65.475c2.647-10.81-5.053-21.408-16.152-22.231l-67.224-4.987c-18.167-1.348-25.546-24.057-11.641-35.826L70.19 269.74c8.495-7.19 8.495-20.289 0-27.479l-51.454-43.548c-13.906-11.769-6.527-34.478 11.641-35.826l67.224-4.987c11.099-.823 18.799-11.421 16.152-22.231l-16.03-65.475c-4.332-17.695 14.986-31.73 30.475-22.142l57.317 35.479c9.463 5.858 21.921 1.81 26.134-8.492l25.516-62.393c6.896-16.861 30.774-16.861 37.67 0zM392 256c0-74.991-61.01-136-136-136-74.991 0-136 61.009-136 136s61.009 136 136 136c74.99 0 136-61.009 136-136zm-32 0c0 57.346-46.654 104-104 104s-104-46.654-104-104 46.654-104 104-104 104 46.654 104 104z"></path></svg></span>
                ${suggest._highlightResult.name.value}
                &nbsp;<small>${suggest.category}</small>
                </div>`;
            }
          }
        };

        // https://github.com/algolia/autocomplete.js#custom-source
        var addressDataset = {
          source: function(query, callback) {

            // API and options: https://docs.mapbox.com/api/search/#geocoding
            // Working with Javascript SDK: https://github.com/mapbox/mapbox-sdk-js
            searchService.forwardGeocode({
              query: query,
              bbox: _config.boundingBoxLonLat, // bounding box Bounding boxes should be supplied as four numbers separated by commas, in minLon,minLat,maxLon,maxLat order
              proximity: _config.centreLonLat, // could use current user position
              autocomplete: true, // returns results results will be included that start with the requested string, rather than just responses that match it exactly.
              limit: 5,
              types: [
                /* 'place', 'locality', 'neighborhood', */
                'postcode', 'address', 'poi'
              ],
            })
              .send()
              .then(response => {
                const match = response.body;
                // console.log('mapbox match: ', match);
                let suggestions2 = match.features.map(f => {
                  return {
                    name: f.place_name.replace(', England', '').replace(', United Kingdom', ''),
                    type: f.place_type[0],
                    latitude: f.geometry.coordinates[1], // assuming result Feature is a POINT
                    longitude: f.geometry.coordinates[0],
                  };
                });
                callback(suggestions2);
              });

          },
          templates: {
            header: '<div class="ad-autocomp-header">Addresses</div>',
            suggestion: function (suggestion) {
              // Embed the SVG directly inline
              // The following SVG include will only look right if we also include the svg-inline--fa fa-map-marker-alt fa-w-12 fontawesome class definitions which are being referenced in the tag
              return `<div>
                <span class="ap-suggestion-icon ap-suggestion-icon-address" style="white-space: normal;"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="map-marker-alt" class="svg-inline--fa fa-map-marker-alt fa-w-12" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"></path></svg></span>
                ${suggestion.name}
                </div>`;
            }
          }
        };

        // init
        //   console.log('checking if the element is available yet');
        //   console.log('address' + that.id);

          // getElementById is not going to work inside a web component due to ShadowDOM restrictions
          // See reason why https://forum.vuejs.org/t/document-getelementbyid-in-shadow-dom-custom-web-element/59957
          // So must use ref instead
          // let addressElement = document.getElementById('address' + that.id);
          // Note grab the unique reference and need the $el inside that which is the elemet which would have been returned by getElementById and which the autocomplete library needs
          let addressElementAlt = that.$refs[`refAddress${that.id}`].$el;
          // console.log("addressElementAlt", addressElementAlt);
          // e.g. this will work now when the autocomplete library calls it with the passed in element (that.$refs.refAddress.$el).getAttribute("type")

          let datasetsToReturn;
          if (that.suggestAddressesFirst) {
            datasetsToReturn = [addressDataset, poisDataset];
          } else {
            datasetsToReturn = [poisDataset, addressDataset];
          }
          var autocompleteInstance = autocomplete(
                  addressElementAlt, // the input field
                  {
                    // https://github.com/algolia/autocomplete.js#global-options
                    minLength: 3,
                    autoselect: true, //  If true, the first rendered suggestion in the dropdown will automatically have the cursor class, and pressing <ENTER> will select it.
                    hint: false,
                    debug: false, //  Setting debug: true will prevent auto-closing of the menu and make styling easier!
                    cssClasses: {prefix: 'ad-autocomp'} // defines which exact classes will be used - see below
                  },
                  datasetsToReturn // the suggestions to return in the dropdown
          );

          // selected when user selects value with moouse/touch.
          // autocompleted fires when they tab out of field
          // Setup for both from and to addresses
          // https://github.com/algolia/autocomplete.js#events
          const events = ['selected', 'autocompleted'];
          events.forEach(function (e) {
            autocompleteInstance.on('autocomplete:' + e, function (event, suggestion /*, datasetName*/) {
              // dataset should be a name but now seems to be a number
              // console.log('datasetName', datasetName);
              // console.log('event', event);
              // console.log('suggestion', suggestion);
              if (suggestion) {
                // if (datasetName === 'places') {
                // Places provide fields called lat and lon but addresses provide latitude and longitude
                // Ideally would test datasource name but not working reliably
                // eslint said switch from this for security: suggestion.hasOwnProperty('lat'))
                if (Object.prototype.hasOwnProperty.call(suggestion, "lat")) {
                  that.addressLat = suggestion.lat;
                  that.addressLon = suggestion.lon;
                } else {
                  that.addressLat = suggestion.latitude;
                  that.addressLon = suggestion.longitude;
                }
                // }
                that.address = suggestion.name; // replace the suggested value into the field (address)
                addressElementAlt.blur(); // remove focus, important on mobile to prevent it keep showing the keyboard subsequenrly as intereact with map

                // now send back to parent -- this is a custom function, see methods
                that.emitEvent();
              }
            });
          });

          // What to do when receive inbound FOCUS event https://github.com/vuejs/vue/issues/4225
          that.$on('focus', function ( /* v */ ) {
            // console.log('AddressSearchField: focus');
            that.$refs[`refAddress${that.id}`].$el.focus();
          });
          that.$on('blur', function ( /* v */ ) {
            // console.log('AddressSearchField: blur');
            that.$refs[`refAddress${that.id}`].$el.blur();
          });

          // If property is set
          if (that.forceFocus) {
            that.focus();
          }
      })();
    });
  },
  methods: {
    resetField: function () {
      // console.log('resetField');
      this.value = '';
      this.address = null;
      this.addressLat = null;
      this.addressLon = null;

      // todo: not sure if should emit blank address details again when they are reset eg. on click on field.
      this.emitEvent();
    },
    emitEvent: function () {
      // See model: definition for the name of the attr which is emitted within the event
      var valueToReturn = {
        address: this.address,
        addressLat: this.addressLat,
        addressLon: this.addressLon,
      };
      this.$emit('got-address', valueToReturn);
    },
    focus: function () {
      this.$refs[`refAddress${this.id}`].$el.focus();
    }
  }
};
</script>
<style lang="scss"> /* dont scope as the algolia widget expects specific names */

// Must import these otherwise they are not accessible in this shadow dom
// See https://medium.com/javascript-in-plain-english/how-to-create-web-components-with-vue-js-25cd8d7dfd47
@import "../../node_modules/bootstrap/dist/css/bootstrap.css";
@import "../../node_modules/bootstrap-vue/dist/bootstrap-vue.css";

// Font awesome classes for the SVG used in the autocomplete above
@import "../../node_modules/@fortawesome/fontawesome-svg-core/styles.css";

  /* algolia autocomplete */

  .algolia-autocomplete { /* applied by the Algolia code as a span around the input field and messes up b-input-group setup as result */
    width: 100%; /* fill the full availabel width with the field */
    z-index: 1001; /* ensure dropdown sits above all other elements on screen (it was disappearing behind Park page top leaflet map */
  }

  /* function call for autocomplete setup defines the class prefix to use (.ad-autocomp) */
  /* doco: https://github.com/algolia/autocomplete.js */
  .ad-autocomp-dropdown-menu {
    width: 100%;
    color: black;
    background-color: #fff;
    border: 1px solid #ccc;
    border-top: none;
    border-radius: 5px;
    padding: .5em;
    box-shadow: 1px 1px 32px -10px rgba(0,0,0,0.62);
  }
  // Note .ap not .ad since referenced by that name in the code above
  .ap-suggestion-icon-place {
    color: #aaaaaa;
  }
  .ap-suggestion-icon-poi {
    color: #31aa43;
  }
  .ad-autocomp-dropdown-menu .ad-autocomp-suggestion {
    cursor: pointer;
    padding: 2px 2px;
    font-size: 1em;
  }
  .ad-autocomp-dropdown-menu .ad-autocomp-suggestion img {
    height: 2em;
    margin-top: .5em;
    margin-right: 10px;
    float: left;
  }
  .ad-autocomp-dropdown-menu .ad-autocomp-suggestion small {
    font-size: .6em;
    color: #248432;
  }
  .ad-autocomp-header {
    font-size: 1em;
    color: #4d5382;
    font-weight: bold;
    padding: .5em 0;
    margin-bottom: 1em;
    border-bottom: 1px solid #ccc;
  }
  .ad-autocomp-dropdown-menu .ad-autocomp-suggestion.ad-autocomp-cursor {
    background-color: #B2D7FF;
  }
  .ad-autocomp-dropdown-menu .ad-autocomp-suggestion em {
    font-weight: bold;
    font-style: normal;
  }

  /* Text input field */
  .ad-autocomp-input {
    background-color: white;
    font-size: 0.9em !important;
  }
  .ad-autocomp-input:before {
    /*content: "\002315";*/
    content: "xxx" !important;
  }
  @media screen and (min-width: 769px) {
    .ad-autocomp-dropdown-menu .ad-autocomp-suggestion small {
      font-size: 0.8em;
    }
    .ad-autocomp-dropdown-menu .ad-autocomp-suggestion {
      padding: 5px 4px;
      font-size: 0.8em;
    }
    .ad-autocomp-header {
      font-size: 0.8em;
    }
    .ad-autocomp-input {
      font-size: 1rem;
    }
  }
</style>
